import React, {useEffect} from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

/** CSS
 */
import './style/css/main.css';
import './style/css/components/ButtonBackToTop.css';

/** COMPONENTS
 */
// import bgVideo from './img/Network - 45961.mp4';
import Header from "./components/Header";
import Home from "./components/Home";
import Sobre from "./components/Sobre";
import Competencias from "./components/Competencias";
import Contato from "./components/Contato";
import Breadcrumb from "./components/Breadcrumb";
import {staggeredFadeInDivEffect} from "./components/staggeredFadeInDivEffect";

import {css} from "styled-components";
import {ClipLoader} from "react-spinners";
const loaderCss = css`
  display: block;
  margin:0 auto;
  border-color:#00A3DE;
  margin-top:48vh;
`;

function App() {

  function checkScrollHeight(){
    let scrollPosition = document.getElementsByClassName('mainWrapper')[0].scrollTop;
    let btn = document.getElementsByClassName('back-to-top')[0];
    if(scrollPosition > 0){
      btn.className = 'back-to-top show'
    }else{
      btn.className = 'back-to-top'
    }
  }

  function backToTop(event){
    let wrapper = document.getElementsByClassName('mainWrapper')[0];
    if(wrapper.scrollTop > 0){
      wrapper.scrollBy(0, -50);
      setTimeout(backToTop, 1);
    }
  }

  useEffect(()=>{
    document.getElementById('particles-js').className = 'hide'
    staggeredFadeInDivEffect(50)
    console.log('Você está avaliando a minha aplicação? Avalia com carinho eim! S2')
  })

  return (
    <>
      <div id="particles-js">
        <ClipLoader css={loaderCss}/>
      </div>
      <div className={`mainWrapper`} onScroll={checkScrollHeight}>

        <Router>
          <Header backToTop={backToTop}/>
          <div className='container-xxl'>
            <Switch>
              <Route exact path='/'>
                <Home/>
              </Route>

              <Route path='/sobre'>
                <Sobre/>
              </Route>

              <Route path='/competencias'>
                <Competencias/>
              </Route>

              <Route path='/contato'>
                <Contato/>
              </Route>

              <Route>
                <Breadcrumb page='404'/>
                <div className="row">
                  <div className="col">
                    <h1>Ops! <i className='la la-grin-beam-sweat'/></h1>
                    <h3>Isso aqui é uma 404</h3>
                    <p>A página que você está procurando não existe.</p>
                  </div>
                </div>
              </Route>

            </Switch>
          </div>
        </Router>

      </div>

      <button type='button' id='back-to-top' className='back-to-top' onClick={backToTop}>
        <i className='la la-angle-up'/>
      </button>

      {/*<div className="fade-enter">
        <div className="bgLogo fade-enter"/>
      </div>*/}

    </>
  );
}

export default App;
